import styled from "styled-components";

import CircularProgress from "@material-ui/core/CircularProgress";

export default function ActionButton({
    icon = null,
    text = null,
    color = '#2c3e50',
    action = () => { },
    onClick = null,
    type = "button",
    loading = false,
    disabled = false,
    variant = null
}) {

    const Icon = icon;

    const getVariantColor = () => {
        if (color && !variant) return color;
        if (variant === 'primary') return '#2c3e50';
        if (variant === 'secondary') return '#6c757d';
        return color;
    };

    return (
        <Button
            color={getVariantColor()}
            onClick={onClick || action}
            type={type}
            disabled={loading || disabled}
        >

            {
                loading ?
                    <CircularProgress size={16} color='white' style={{ opacity: '1 !important' }} /> :
                    icon && <Icon />
            }
            {
                text && <p>{text}</p>
            }
        </Button>
    )
}

const Button = styled.button`
    color: #fff;
    background-color: ${props => props.color};
    border: 0;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    padding: 12px 24px;
    min-width: 100px;
    min-height: 48px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    font-family: 'Mulish', sans-serif;
    letter-spacing: 0.3px;
    flex: 1;



    &:hover:not(:disabled){
        opacity: 0.9;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    &:active:not(:disabled){
        transform: translateY(0);
    }

    &:disabled{
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    }



    p {
        margin: 0;
        font-size: 14px;
        font-weight: 600;
    }

`;
